export enum CONTENT_DIRECTION {
  RTL = 'rtl',
  LTR = 'ltr',
}
